/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcCore from "@grapecity/wijmo"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import { Button, Card, Col, Collapse, Container, Row } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faChevronUp, faSearch } from "@fortawesome/free-solid-svg-icons"

import { useHistory, useLocation } from "react-router-dom"
import AlertComponent from "../../../components/AlertComponent"

import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { TSyaryo, TSyaryoMasterListGetReq } from "../../../service/truck/TSyaryo"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"

import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { TWijmoComboBox } from "../../../type/wijmoComponents"

import ComboBox from "../../../components/ComboBox"
import { AppDispatch } from "../../.."
import { clearAlert, setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import util from "../../../ts/util"
import { メニューコード } from "../../../constant/menuCode"
import { 区分分類コード } from "../../../constant/enum/codes"

import { T営業所管マスタ } from "../../../components/ComboBox/EigyosyokanComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import KubunService from "../../../service/master/kubun/kubunService"
import { T営業所マスタ } from "../../../components/ComboBox/EigyosyoComboBox"
import EigyosyoKanService from "../../../service/master/eigyosyoKan/eigyosyoKanService"
import EigyosyoService from "../../../service/master/eigyosyo/eigyosyoService"
import { eETC設置区分 } from "../../../constant/enum/syaryo"
import SyaryoService from "../../../service/truck/syaryoService"
import NumberInput from "../../../components/InputWrapper/NumberInput"
import { Form } from "react-bootstrap"
import commonUtil from "../../../ts/util/commonUtil"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
// import { T会社マスタ } from "../../../components/ComboBox/KaisyaComboBox"
// import KaisyaService from "../../../service/master/kaisya/kaisyaService"

//#region [type]

// DefaultCombo
export type TItem = { name: string; value: any }

export type T車輌明細リスト = TSyaryo & {
  行ID: symbol
}
//#endregion

export type TGridDataItem = Partial<{}>

/**
 * 車輌マスタ一覧
 * @returns
 */
const SyaryoMasterList = () => {
  const history = useHistory()
  const location = useLocation()

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find((m) => m.メニューコード === メニューコード.車輌管理.車輌マスタ)?.読み取り専用フラグ
  )

  //TODO:ページ名称確定必須
  let gridId = "SyaryoMasterList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<T車輌明細リスト>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {
        sort_社員コード: (i: T車輌明細リスト) =>
          commonUtil.createSortString(i.社員コード, VALIDATE_CONSTANT.LENGTH.社員コード),
        sort_車番: (i: T車輌明細リスト) => commonUtil.createSortString(i.車番, VALIDATE_CONSTANT.LENGTH.車番),

        // Grid標準の表示列設定POPの表示の為に文字列置き換えする（CellTemplate使わない）
        column_原動機: (i: T車輌明細リスト) => {
          if (i.原動機有無フラグ === 1) {
            return "有"
          } else {
            return "無"
          }
        },
        column_ETC設置区分コード_ETC1_0: (i: T車輌明細リスト) => {
          if (i.ETC設置区分コード === eETC設置区分.ETC1_0) {
            return "○"
          } else {
            return "" //"x"
          }
        },
        column_ETC設置区分コード_ETC2_0: (i: T車輌明細リスト) => {
          if (i.ETC設置区分コード === eETC設置区分.ETC2_0) {
            return "○"
          } else {
            return "" //"x"
          }
        },
        column_廃車保管: (i: T車輌明細リスト) => {
          if (i.廃車年月) {
            if (i.廃車保管フラグ === 1) {
              return "あり"
            } else {
              return "なし"
            }
          } else {
            return ""
          }
        },
      },

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyaryoMasterListGetReq, signal?: AbortSignal) => {
    setSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) //Alertクリア

    let currentSearchCondition: TSyaryoMasterListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(createDisplaySearchCondition(currentSearchCondition))

    try {
      const res = await new SyaryoService().getMasterList(currentSearchCondition, signal)

      // 検索結果をstateにセット
      setGridData({
        data: createCollectionView(
          res.data.map((v) => {
            return {
              ...v,
              行ID: Symbol(),
            }
          }),
          pageSize
        ),
      })

      //setAccordionController(false)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyaryoMasterListGetReq = queryString.parse(location.search)
    set車番(query.車番 ?? "")
    set車輌id(query.車輌ID != null && !isNaN(query.車輌ID) ? query.車輌ID : undefined)
    set担当者(query.乗務員名 ?? "")
    set営業所管コード(query.営業所管コード ?? "")
    set営業所コード(query.営業所コード ?? "")
    set部所コード(query.部所コード ?? "")
    set廃車予定フラグ(query.廃車予定フラグ != null ? query.廃車予定フラグ.toString() : null)
    set原動機フラグ(query.原動機有無フラグ != null ? query.原動機有無フラグ.toString() : null)
    set車種区分コード(query.車種区分コード ?? "")
    set車名_メーカー(query.メーカー車名 ?? "")
    set車台番号(query.車台番号 ?? "")
    setシリアルNO(query.シリアルNo ?? "")

    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyaryoMasterListGetReq => {
    return {
      車番,
      車輌ID: 車輌id != null && !isNaN(車輌id) ? 車輌id : undefined,
      乗務員名: 担当者,
      // 会社コード: 会社コード ?? "",
      営業所管コード: 営業所管コード ?? "",
      営業所コード: 営業所コード ?? "",
      部所コード: 部所コード ?? "",
      廃車予定フラグ:
        廃車予定フラグ != null && !wjcCore.isNullOrWhiteSpace(廃車予定フラグ) ? parseInt(廃車予定フラグ) : undefined,
      原動機有無フラグ:
        原動機フラグ != null && !wjcCore.isNullOrWhiteSpace(原動機フラグ) ? parseInt(原動機フラグ) : undefined,
      車種区分コード: 車種区分コード ?? "",
      陸運支局報告分類区分コード: 陸運支局報告分類区分コード ?? "",
      メーカー車名: 車名_メーカー,
      車台番号,
      シリアルNo: シリアルNO,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TSyaryoMasterListGetReq) => {
    return {
      車番: searchCondition.車番 ?? "",
      車輌ID: searchCondition.車輌ID ?? "",
      乗務員名: searchCondition.乗務員名,
      // 会社: 会社ItemSource?.find(
      //   (i) => i.会社コード === searchCondition.会社コード
      // )?.会社略称,
      営業所管: 営業所管ItemSource?.find((i) => i.営業所管コード === searchCondition.営業所管コード)?.営業所管名,
      営業所: 営業所ItemSource?.find((i) => i.営業所コード === searchCondition.営業所コード)?.営業所名,
      部所: 部所ItemSource?.find((i) => i.部所コード === searchCondition.部所コード)?.部所名,
      廃車予定: 廃車予定リスト?.find((i) => i.value === searchCondition.廃車予定フラグ?.toString())?.name,
      原動機: boolList?.find((i) => i.value === searchCondition.原動機有無フラグ?.toString())?.name,
      車種: 区分ItemSource?.find(
        (i) => i.区分コード === searchCondition.車種区分コード && i.分類コード === 区分分類コード.車輌.車種区分
      )?.名称1,
      陸運支局報告分類: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.陸運支局報告分類区分コード &&
          i.分類コード === 区分分類コード.車輌.陸運支局分類区分
      )?.名称1,
      メーカー車名: searchCondition.メーカー車名,
      車台番号: searchCondition.車台番号,
      シリアルNo: searchCondition.シリアルNo,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!searching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)
    // 検索項目をクリア
    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // アコーディオンを開く
    setAccordionController(true)
  }

  const clearSearchState = () => {
    set車番("")
    set車輌id(NaN)
    set担当者("")
    set営業所管コード("")
    set営業所コード("")
    set部所コード("")
    set廃車予定フラグ("")
    set原動機フラグ("")
    set車種区分コード("")
    set陸運支局報告分類区分コード("")
    set車名_メーカー("")
    set車台番号("")
    setシリアルNO("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    var extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダー行に文言追加
    columnHeaders.columns.forEach((c, index) => {
      c.allowMerging = true
      c.align = "left"
      if (c.binding?.includes("デジタコ")) {
        columnHeaders.setCellData(0, index, "デジタルタコメーター")
      } else if (c.binding?.includes("ドラレコ")) {
        columnHeaders.setCellData(0, index, "ドライブレコーダー")
      } else if (c.binding?.includes("ETC")) {
        columnHeaders.setCellData(0, index, "ETC装着状況")
      } else if (c.binding?.includes("インターロック有無フラグ")) {
        columnHeaders.setCellData(0, index, "安全装置")
      } else if (c.binding?.includes("回転灯有無フラグ")) {
        columnHeaders.setCellData(0, index, "警報装置")
      } else if (c.binding?.includes("ランプ有無フラグ")) {
        columnHeaders.setCellData(0, index, "警報装置")
      } else if (c.binding?.includes("タイヤサイズ")) {
        columnHeaders.setCellData(0, index, "タイヤサイズ")
      } else if (c.binding?.includes("ブザー有無フラグ")) {
        columnHeaders.setCellData(0, index, "警報装置")
      } else if (c.binding?.includes("重量") || c.binding === "最大積載量") {
        c.align = "right"
        columnHeaders.setCellData(0, index, c.header)
      } else {
        columnHeaders.setCellData(0, index, c.header)
      }
    })

    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      const rowData: T車輌明細リスト = e.getRow().dataItem
      let isExistData = true
      if (!rowData) return

      // エラー箇所の背景色を設定
      if (errorCellPositionList.find((e) => e.colBinding === cellBinding && e.行ID === rowData.行ID)) {
        isExistData = false
      }
      wjcCore.toggleClass(e.cell, "quantity-error", !isExistData)
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(15)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [searching, setSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // grid内エラー項目格納Array
  const [errorCellPositionList] = useState<Array<{ 行ID: symbol; colBinding: string }>>([])
  const [Form外エラーメッセージList] = useState<string[]>([])
  //　エラー表示用フラグ
  // const [isInvalid会社コード, setIsInvalid会社コード] = useState<boolean>()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  // ComboBoxState
  // // 会社ComboBox
  // const [会社ComboBox, set会社ComboBox] = useState<TWijmoComboBox<
  //   string,
  //   T会社マスタ
  // > | null>(null)
  // const [会社ItemSource, set会社ItemSource] = useState<T会社マスタ[]>()
  // const [会社isLoadEnded, set会社isLoadEnded] = useState<boolean>(false)

  const [車種ComboBox, set車種ComboBox] = useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [車種IsLoadEnded, set車種IsLoadEnded] = useState<boolean>(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  const [廃車予定ComboBox, set廃車予定ComboBox] = useState<TWijmoComboBox<number, TItem> | null>(null)
  const [廃車予定IsLoadEnded, set廃車予定IsLoadEnded] = useState<boolean>(false)
  const [廃車予定ItemSource, set廃車予定ItemSource] = useState<TItem[]>()

  const [原動機ComboBox, set原動機ComboBox] = useState<TWijmoComboBox<number, TItem> | null>(null)
  const [原動機IsLoadEnded, set原動機IsLoadEnded] = useState<boolean>(false)
  const [原動機ItemSource, set原動機ItemSource] = useState<TItem[]>()

  const [営業所管ComboBox, set営業所管ComboBox] = useState<TWijmoComboBox<string, T営業所管マスタ> | null>(null)
  const [営業所管IsLoadEnded, set営業所管IsLoadEnded] = useState<boolean>(false)
  const [営業所管ItemSource, set営業所管ItemSource] = useState<T営業所管マスタ[]>()

  const [営業所ComboBox, set営業所ComboBox] = useState<TWijmoComboBox<string, T営業所マスタ> | null>(null)
  const [営業所IsLoadEnded, set営業所IsLoadEnded] = useState<boolean>(false)
  const [営業所ItemSource, set営業所ItemSource] = useState<T営業所マスタ[]>()

  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<string, T部所マスタ> | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  // const [陸運支局報告分類区分ComboBox, set陸運支局報告分類区分ComboBox] =
  //   useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  // const [陸運支局報告分類区分isLoadEnded, set陸運支局報告分類区分isLoadEnded] =
  //   useState<boolean>(false)

  // 設定
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  const [車番, set車番] = useState<string>("")
  const [車輌id, set車輌id] = useState<number>()

  const [担当者, set担当者] = useState<string>("")
  // const [会社コード, set会社コード] = useState<string | null | undefined>(null)
  const [営業所管コード, set営業所管コード] = useState<string | null>(null)
  const [営業所コード, set営業所コード] = useState<string | null>(null)
  const [部所コード, set部所コード] = useState<string | null>(null)

  const [廃車予定フラグ, set廃車予定フラグ] = useState<string | null>(null)
  const [原動機フラグ, set原動機フラグ] = useState<string | null>(null)
  const [車種区分コード, set車種区分コード] = useState<string | null>(null)
  const [陸運支局報告分類区分コード, set陸運支局報告分類区分コード] = useState<string | null>(null)

  const [車名_メーカー, set車名_メーカー] = useState<string>("")
  const [車台番号, set車台番号] = useState<string>("")
  const [シリアルNO, setシリアルNO] = useState<string>("")

  //#endregion

  //#region [validation]

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = (): boolean => {
    dispatch(clearAlert())
    errorCellPositionList.splice(0, errorCellPositionList.length)
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    if (flexGrid !== undefined) {
      const data: Array<T車輌明細リスト> = flexGrid.itemsSource.items
      // let isDateError = false
      for (let dataIndex in data) {
        const rowDataItem = data[dataIndex]
        let today = Date.parse(eigyobi)

        // 有効期限チェック
        if (rowDataItem.車検満了日) {
          let target有効期限 = Date.parse(rowDataItem.車検満了日)
          let to有効期限 = (target有効期限 - today) / 86400000
          if (to有効期限 < 0) {
            errorCellPositionList.push({
              行ID: data[dataIndex].行ID,
              colBinding: "車検期限まで",
            })
            // isDateError = true
          }
        }

        if (rowDataItem.基準緩和有効期限) {
          let target緩和期限 = Date.parse(rowDataItem.基準緩和有効期限)
          let to緩和期限 = (target緩和期限 - today) / 86400000
          if (to緩和期限 < 0) {
            errorCellPositionList.push({
              行ID: data[dataIndex].行ID,
              colBinding: "基準緩和期限まで",
            })
          }
        }
      }
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    flexGrid?.refresh()
    return !hasError
  }

  ////#endregion

  //#region [effect]

  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
      new EigyosyoKanService().getList(),
      new EigyosyoService().getList(),
      // new KaisyaService().getList(),
    ]).then(
      ([
        部所ListRes,
        区分マスタRes,
        営業所管Res,
        営業所Res,
        // , 会社Res
      ]) => {
        set部所ItemSource(部所ListRes.data)
        set区分ItemSource(区分マスタRes.data)
        set原動機ItemSource(boolList)
        set廃車予定ItemSource(廃車予定リスト)
        set営業所管ItemSource(営業所管Res.data)
        set営業所ItemSource(営業所Res.data)
        // set会社ItemSource(会社Res.data)
      }
    )
  }, [])

  useEffect(() => {
    if (
      !営業所管IsLoadEnded ||
      !営業所IsLoadEnded ||
      !部所IsLoadEnded ||
      !廃車予定IsLoadEnded ||
      !原動機IsLoadEnded ||
      !車種IsLoadEnded
      // !陸運支局報告分類区分isLoadEnded
    )
      return

    setComboDataInitialized(true)
  }, [
    営業所管IsLoadEnded,
    営業所IsLoadEnded,
    部所IsLoadEnded,
    廃車予定IsLoadEnded,
    原動機IsLoadEnded,
    車種IsLoadEnded,
    // 陸運支局報告分類区分isLoadEnded,
  ])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition)
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
      }
    }
  }, [gridInitialized, comboDataInitialized])

  // 検索時にValidation入れると空振りするのでuseEffectで監視
  useEffect(() => {
    if (!gridData) return
    isValidationCheckBeforeSearch()
  }, [gridData])

  // error監視して表示する
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      dispatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  useEffect(() => {
    document.title = `車輌マスタ一覧`
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">車輌マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-130rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon icon={accordionController ? faChevronDown : faChevronUp} size={"1x"} />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="input-group">
                              <TextInput
                                style={{ width: "5rem" }}
                                id="車番"
                                name="車番"
                                autoFocus={true}
                                value={車番}
                                setValue={set車番}
                                maxLength={4}
                                placeholder="車番"
                              />
                              <NumberInput
                                style={{ width: "5rem" }}
                                id="車輌id"
                                name="車輌id"
                                value={車輌id}
                                setValue={set車輌id}
                                placeholder="ID"
                              />
                            </div>
                            <TextInput
                              id="担当者"
                              name="担当者"
                              value={担当者}
                              setValue={set担当者}
                              maxLength={30}
                              placeholder="担当乗務員"
                            />
                            {/* <ComboBox.Kaisya
                              placeholder="会社"
                              isAllSelect={true}
                              itemsSource={会社ItemSource}
                              isLoadEnded={会社isLoadEnded}
                              setIsLoadEnded={set会社isLoadEnded}
                              selectedValue={会社コード}
                              setSelectedValue={set会社コード}
                              // className={isInvalid会社コード ? "is-error" : ""}
                              ComboBox={会社ComboBox}
                              setComboBox={set会社ComboBox}></ComboBox.Kaisya> */}
                            <ComboBox.Eigyosyokan
                              placeholder="営業所管"
                              isAllSelect={true}
                              itemsSource={営業所管ItemSource}
                              selectedValue={営業所管コード}
                              setSelectedValue={set営業所管コード}
                              isLoadEnded={営業所管IsLoadEnded}
                              setIsLoadEnded={set営業所管IsLoadEnded}
                              ComboBox={営業所管ComboBox}
                              setComboBox={set営業所管ComboBox}></ComboBox.Eigyosyokan>
                            <ComboBox.Eigyosyo
                              placeholder="営業所"
                              isAllSelect={true}
                              itemsSource={営業所ItemSource}
                              selectedValue={営業所コード}
                              setSelectedValue={set営業所コード}
                              isLoadEnded={営業所IsLoadEnded}
                              setIsLoadEnded={set営業所IsLoadEnded}
                              ComboBox={営業所ComboBox}
                              setComboBox={set営業所ComboBox}></ComboBox.Eigyosyo>
                            <ComboBox.Busyo
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              selectedValue={部所コード}
                              setSelectedValue={set部所コード}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                            {/* <ComboBox.Kubun
                              placeholder="陸運支局報告分類"
                              分類コード="C0002"
                              isLoadEnded={陸運支局報告分類区分isLoadEnded}
                              setIsLoadEnded={
                                set陸運支局報告分類区分isLoadEnded
                              }
                              isAllSelect={true}
                              isRequired={true}
                              itemsSource={区分ItemSource}
                              selectedValue={陸運支局報告分類区分コード}
                              setSelectedValue={(v) => {
                                set陸運支局報告分類区分コード(v)
                              }}
                              ComboBox={陸運支局報告分類区分ComboBox}
                              setComboBox={
                                set陸運支局報告分類区分ComboBox
                              }></ComboBox.Kubun> */}
                          </div>
                          <div className="search-condition-row">
                            <ComboBox.Default
                              className="max-w-10rem"
                              placeholder="原動機"
                              isAllSelect={true}
                              itemsSource={原動機ItemSource}
                              selectedValue={原動機フラグ}
                              setSelectedValue={set原動機フラグ}
                              isLoadEnded={原動機IsLoadEnded}
                              setIsLoadEnded={set原動機IsLoadEnded}
                              ComboBox={原動機ComboBox}
                              setComboBox={set原動機ComboBox}></ComboBox.Default>
                            <ComboBox.Kubun
                              placeholder="車種"
                              分類コード={区分分類コード.車輌.車種区分}
                              isAllSelect={true}
                              itemsSource={区分ItemSource}
                              selectedValue={車種区分コード}
                              setSelectedValue={set車種区分コード}
                              isLoadEnded={車種IsLoadEnded}
                              setIsLoadEnded={set車種IsLoadEnded}
                              ComboBox={車種ComboBox}
                              setComboBox={set車種ComboBox}></ComboBox.Kubun>
                            <TextInput
                              id="車名_メーカー"
                              name="車名_メーカー"
                              value={車名_メーカー}
                              setValue={set車名_メーカー}
                              maxLength={30}
                              placeholder="メーカー"
                            />
                            <TextInput
                              style={{ width: "16.8rem" }}
                              id="車台番号"
                              name="車台番号"
                              value={車台番号}
                              setValue={set車台番号}
                              maxLength={30}
                              placeholder="車台番号"
                            />
                            <TextInput
                              style={{ width: "16.9rem" }}
                              id="シリアルNO"
                              name="シリアルNO"
                              value={シリアルNO}
                              setValue={setシリアルNO}
                              maxLength={30}
                              placeholder="シリアルNO"
                            />
                            <ComboBox.Default
                              className="max-w-15rem"
                              placeholder="廃車車輌"
                              isAllSelect={true}
                              itemsSource={廃車予定ItemSource}
                              selectedValue={廃車予定フラグ}
                              setSelectedValue={set廃車予定フラグ}
                              isLoadEnded={廃車予定IsLoadEnded}
                              setIsLoadEnded={set廃車予定IsLoadEnded}
                              ComboBox={廃車予定ComboBox}
                              setComboBox={set廃車予定ComboBox}></ComboBox.Default>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={searching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={searching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel displaySearchCondition={displaySearchCondition} />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={true}
                gridProperties={{
                  frozenColumns: 6,
                  // allowSorting: wjGrid.AllowSorting.None,
                  // allowDragging: wjGrid.AllowDragging.None,
                }}
                headerComponent={
                  <>
                    {!読取専用フラグ && (
                      <Button
                        disabled={searching}
                        onClick={() => {
                          gridPageHelper.savePageConditionData(location.pathname)
                          // 車輌マスタ登録へ遷移
                          const path = util.getMenuPath(メニューコード.車輌管理.車輌マスタ登録)
                          history.push(path[0])
                        }}>
                        <FontAwesomeIcon icon={faPlusSquare} />
                        新規追加
                      </Button>
                    )}
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  allowDragging={false}
                  align="center"
                  width={60}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      // 車輌マスタ登録
                      const url = util.getMenuPath(メニューコード.車輌管理.車輌マスタ登録)[1]
                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(location.pathname)

                            history.push(url.replaceAll(":id", `${context.item.車輌ID}`))
                          }}>
                          {!読取専用フラグ ? "編集" : "参照"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                {/* <wjrGrid.FlexGridColumn
                  binding="会社略称"
                  width={100}
                  header="会社"></wjrGrid.FlexGridColumn> */}
                <wjrGrid.FlexGridColumn
                  allowDragging={false}
                  binding="営業所管名"
                  width={100}
                  header="営業所管"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  allowDragging={false}
                  binding="営業所名"
                  width={90}
                  header="営業所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  allowDragging={false}
                  binding="部所名"
                  width={170}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  allowDragging={false}
                  binding="車番"
                  width={60}
                  sortMemberPath="sort_車番"
                  header="車番"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  allowDragging={false}
                  binding="登録番号"
                  width={150}
                  header="登録番号"></wjrGrid.FlexGridColumn>
                {/* ここまで固定列 */}

                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={80}
                  sortMemberPath="sort_社員コード"
                  header="社員CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="社員氏名" width={128} header="乗務員名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="メーカー車名"
                  width={150}
                  header="メーカー車名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="陸運支局分類区分名称1"
                  width={160}
                  header="陸運支局報告分類"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="column_原動機" width={80} header="原動"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車種区分名称1" width={140} header="車種"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車体形状" width={140} header="車体形状"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="稼働手当車種掛率区分名称1"
                  width={120}
                  dataType="String"
                  header="稼働掛率"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車輌ID" width={100} format="N0" header="車輌ID">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      let displayItem
                      if (context.item.車輌ID != null || context.item.車輌ID < 0) {
                        displayItem = ""
                      }
                      displayItem = context.item.車輌ID.toString()
                      return <div className="text-end">{displayItem}</div>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="初年度登録年月" width={140} dataType="Date" header="初年度登録年月">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      return (
                        <>
                          {context.item.初年度登録年月 &&
                            wjcCore.Globalize.format(new Date(context.item.初年度登録年月), "d")}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車検満了日" width={128} dataType="Date" header="車検満了日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      return (
                        <>
                          {context.item.車検満了日 && wjcCore.Globalize.format(new Date(context.item.車検満了日), "d")}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車輌形式" width={128} header="車輌型式"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="原動機型式" width={90} header="原動型式"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車台番号" width={128} header="車台番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="シリアルNO" width={128} header="シリアルNO"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車種詳細" width={128} header="車種詳細"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車検満了日" width={128} dataType="Date" header="有効期限">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      return (
                        <>
                          {context.item.車検満了日 && wjcCore.Globalize.format(new Date(context.item.車検満了日), "d")}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車検有効期限までの日数"
                  width={128}
                  header="期限まで"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn binding="登録年月日" width={128} dataType="Date" header="登録年月日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      return (
                        <>
                          {context.item.登録年月日 && wjcCore.Globalize.format(new Date(context.item.登録年月日), "d")}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="最大積載量"
                  width={128}
                  align="right"
                  header="最大積載量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車輌重量"
                  width={128}
                  align="right"
                  header="車輌重量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車輌総重量"
                  width={128}
                  align="right"
                  header="車輌総重量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="所有者名称" width={180} header="所有者名称"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="使用者情報_会社名"
                  width={180}
                  header="使用者名称"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="車輌営業所区分名称1"
                  width={128}
                  header="車輌営業所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="基準緩和車輌"
                  width={128}
                  header="基準緩和車輌"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="緩和書類制作会社"
                  width={150}
                  header="緩和書類制作会社"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="緩和輸送依頼荷主"
                  width={150}
                  header="緩和輸送依頼荷主"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="基準緩和有効期限" width={100} dataType="Date" header="緩和期限">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      return (
                        <>
                          {context.item.基準緩和有効期限 &&
                            wjcCore.Globalize.format(new Date(context.item.基準緩和有効期限), "d")}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="緩和期限までの日数"
                  width={100}
                  header="期限まで"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="架装メーカー" width={128} header="架装"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="架装タンクNO"
                  width={128}
                  header="架装・タンクNO"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="台帳保管ファイル名"
                  width={128}
                  header="台帳保管ファイル名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="デジタコ有無フラグ" width={60} align="center" header="有無">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      let displayItem = ""
                      if (context.item.デジタコ有無フラグ === 1) {
                        displayItem = "○"
                      }
                      return <>{displayItem}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="デジタコメーカー"
                  width={128}
                  header="メーカー"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="デジタコ型式" width={128} header="型式"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="ドラレコ有無フラグ" width={60} header="有無">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      let displayItem = ""
                      if (context.item.ドラレコ有無フラグ === 1) {
                        displayItem = "○"
                      }
                      return <>{displayItem}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ドラレコメーカー"
                  width={128}
                  header="メーカー"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="ドラレコ型式" width={128} header="型式"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="column_ETC設置区分コード_ETC1_0"
                  width={80}
                  header="ETC"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="column_ETC設置区分コード_ETC2_0"
                  width={80}
                  header="ETC2.0"></wjrGrid.FlexGridColumn>

                <wjrGrid.FlexGridColumn binding="インターロック有無フラグ" width={130} header="インターロック">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      let displayItem = ""
                      if (context.item.インターロック有無フラグ === 1) {
                        displayItem = "○"
                      }
                      return <>{displayItem}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="回転灯有無フラグ" width={80} header="回転灯">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      let displayItem = ""
                      if (context.item.回転灯有無フラグ === 1) {
                        displayItem = "○"
                      }
                      return <>{displayItem}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="ランプ有無フラグ" width={80} header="ランプ">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      let displayItem = ""
                      if (context.item.ランプ有無フラグ === 1) {
                        displayItem = "○"
                      }
                      return <>{displayItem}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="ブザー有無フラグ" width={80} header="ブザー">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      let displayItem = ""
                      if (context.item.ブザー有無フラグ === 1) {
                        displayItem = "○"
                      }
                      return <>{displayItem}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  allowDragging={false}
                  binding="タイヤサイズフロント"
                  width={200}
                  header="フロント"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  allowDragging={false}
                  binding="タイヤサイズ軸"
                  width={100}
                  header="軸"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="変更前車番" header="変更前車番"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="変更前登録番号"
                  width={128}
                  header="変更前登録番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="車番変更備考" width={200} header="備考"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="廃車予定年月"
                  width={140}
                  // dataType="Date"
                  header="廃車予定年月">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      return (
                        <>
                          {context.item.廃車予定年月 &&
                            wjcCore.Globalize.format(new Date(context.item.廃車予定年月), "d")}
                        </>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="廃車年月"
                  width={140}
                  // dataType="Date"
                  header="廃車年月">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      return (
                        <>{context.item.廃車年月 && wjcCore.Globalize.format(new Date(context.item.廃車年月), "d")}</>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="column_廃車保管"
                  width={110}
                  header="廃車保管"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn binding="借用車フラグ" width={90} align="center" header="借用車">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<T車輌明細リスト>) => {
                      let displayItem = ""
                      if (context.item.借用車フラグ === 1) {
                        displayItem = "○"
                      }
                      return <>{displayItem}</>
                    }}
                  />
                </wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default SyaryoMasterList

// defaultComboBox用
const boolList: TItem[] = [
  {
    name: "有",
    value: "1",
  },
  {
    name: "無",
    value: "0",
  },
]

// バックエンド側はValueの値により処理分岐させる
const 廃車予定リスト: TItem[] = [
  {
    name: "廃車車輌（すべて）",
    value: "1",
  },
  {
    name: "廃車（保管あり）",
    value: "2",
  },
  {
    name: "廃車（保管なし）",
    value: "3",
  },
  {
    name: "廃車除く",
    value: "4",
  },
]
//#endregion
